<template>
  <div class="content-wrapper" v-if="task">
    <h1>Update Task</h1>
    <Task :task="task"></Task>

    <div class="button-container">
      <button v-if="displaySaveButton" :disabled="disableButtons" class="button button--thin" @click="updateTask(task.status, task.status, 'save')">Save</button>
      <button
        :disabled="disableButtons"
        v-if="task.status == 'claimed' && !user.data.firestore.isAdmin"
        class="button button--thin button--margin-left"
        data-cy="review-button"
        @click="updateTask(task.status, 'pending-review', 'submit this task')"
      >
        Submit task
      </button>

      <template v-if="user.data.firestore.isAdmin">
        <button
          :disabled="disableButtons"
          v-if="task.status == 'revision-needed'"
          class="button button--thin button--margin-left"
          data-cy="review-button"
          @click="updateTask(task.status, 'pending-review', 'change back to pending review')"
        >
          Pending review
        </button>
        <button :disabled="disableButtons" v-if="task.status == 'pending-review'" class="button button--thin button--margin-left button--danger" data-cy="revision-button" @click="modalOpen = true">
          Needs revision
        </button>
        <button
          :disabled="disableButtons"
          v-if="task.status == 'pending-review'"
          class="button button--thin button--margin-left"
          data-cy="approve-button"
          @click="updateTask(task.status, 'approved', 'approve this task')"
        >
          Approve
        </button>
        <button :disabled="disableButtons" v-if="task.status == 'approved'" class="button button--thin button--margin-left button--danger" data-cy="revision-button" @click="modalOpen = true">
          Needs revision
        </button>
        <button :disabled="disableButtons" v-if="task.status == 'approved'" class="button button--thin button--margin-left" @click="updateTask(task.status, 'exported', 'mark this task as exported')">
          Mark as exported
        </button>
        <button
          :disabled="disableButtons"
          v-if="task.status == 'exported'"
          class="button button--thin button--margin-left button--danger"
          @click="updateTask(task.status, 'approved', 'change back to approved')"
        >
          Change back to Approved
        </button>
      </template>
      <RevisionEmail v-if="modalOpen" :email="emailData" :submittedBy="task.claimedBy" :taskStatus="task.status" v-on:update:modalOpen="modalOpen = $event"></RevisionEmail>
    </div>
  </div>
</template>

<script>
import Task from '@/components/task'
import axios from 'axios'
import RevisionEmail from '@/components/revisionemail'
import { mapActions, mapGetters, mapMutations } from 'vuex'
import emailApi from '@/api/email'

export default {
  name: 'taskId',
  data() {
    return {
      disableButtons: false,
      modalOpen: false,
      emailData: {
        subject: 'Your task needs revision',
        recipients: [],
        body: '',
      },
    }
  },
  methods: {
    ...mapActions(['fetchTaskById', 'saveTask']),
    onClose(newData) {
      this.modalOpen = newData
    },
    async updateTask(currentStatus, newStatus, message) {
      this.disableButtons = true
      this.task.status = newStatus

      await this.$dialog.confirm('Are you sure you want to ' + message + '?')

      try {
        await this.saveTask({ task: this.task })

        if (status == 'revision-needed' && this.emailData.body != '') {
          emailApi.sendEmail(this.emailData)
        }

        this.$notify({
          text: 'Successfully saved task',
          type: 'success',
        })
      } catch (error) {
        this.task.status = currentStatus

        this.$notify({
          text: 'Failed to save task',
          type: 'error',
        })
      }
    },
  },
  mounted: function() {
    this.fetchTaskById({ userId: this.user.data.uid, taskId: this.$route.params.id })
  },
  computed: {
    ...mapGetters(['task', 'user']),
    displaySaveButton() {
      if (this.user.data.firestore.isAdmin) {
        return true
      }
      if (this.task.status === 'claimed' || this.task.status === 'revision-needed') {
        return true
      }
      return false
    },
  },
  components: {
    Task,
    RevisionEmail,
  },
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared-styles/button.scss';

.button-container {
  display: flex;
  margin-left: auto;
}
</style>
